import { Sort } from '@angular/material/sort';

export function matSortTransformer({ direction, active }: Sort): string {
  return direction === 'desc' ? `-${active}` : active;
}
